import { AutoComplete } from '@openx/components-core/lib/AutoComplete/AutoComplete.tsx';
import type { VideoOption } from '@openx/types/targeting/video.ts';
import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { useTargetingOptionDisabledState } from '../../../utils/hooks/useTargetingOptionDisabledState.ts';
import { useVideoTypeOptions } from '../hooks/useVideoTypeOptions.ts';

type VideoTypeOptionProps = {
  onChange: (type: VideoOption) => void;
  value: VideoOption;
};

export const TypeOptionDropdown = (props: VideoTypeOptionProps): JSX.Element => {
  const { onChange, value } = props;
  const { t } = useTranslation();
  const { options, getOptionLabel } = useVideoTypeOptions();
  const { isOptionDisabled } = useTargetingOptionDisabledState();

  return (
    <AutoComplete<VideoOption, false, true, false>
      textFieldProps={{ label: t('Type') }}
      options={options}
      renderOptions={{
        dataTest: 'type-option',
      }}
      getOptionLabel={getOptionLabel}
      getOptionDisabled={option => isOptionDisabled(option)}
      textFieldReadOnly
      disableClearable
      filterOptions={option => option}
      onChange={(_e, value) => onChange(value)}
      value={value}
      fullWidth
      data-test="video-type"
    />
  );
};
